import { render, staticRenderFns } from "./KitAvatar.vue?vue&type=template&id=9685fd9a&scoped=true&"
import script from "./KitAvatar.vue?vue&type=script&lang=ts&"
export * from "./KitAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9685fd9a",
  null
  
)

export default component.exports